// import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
// import axiosInstance from 'Services/APIService';
// import { fetchIncidents } from '../carporateServices/IncidentsListSlice';

// // Define the form data type
// export interface ClientIncidentFormData {
//   id?: string;
//   date_of_incident: string;
//   time_of_incident: string;
//   location_of_incident: string;
//   description: string;
//   individuals_involved: string;
//   witnesses?: string;
//   actions_taken_during: string;
//   client_name: string;
//   ndis_number: string;
//   client_condition: string;
//   was_injured: string;
//   injury_description?: string;
//   first_aid_provided?: string;
//   property_damage: string;
//   damage_description?: string;
//   immediate_actions: string;
//   escalated_to_management: string;
//   manager_name?: string;
//   reported_externally: string;
//   external_party?: string;
//   follow_up: string;
//   recommendations: string;
//   support_worker_name: string;
//   support_worker_signature: string;
//   date_completed: string;
//   photo?: File | string;
//   client_email?: string;
//   resolved?: boolean;
// }

// // Define the state type
// export interface ClientIncidentState {
//   loading: boolean;
//   message: string | null;
//   error: string | null;
// }

// // Define the initial state
// const initialState: ClientIncidentState = {
//   loading: false,
//   message: null,
//   error: null
// };

// // Helper function to convert file to base64
// const convertFileToBase64 = (file: File): Promise<string> => {
//   return new Promise((resolve, reject) => {
//     const reader = new FileReader();
//     reader.onload = () => resolve(reader.result as string);
//     reader.onerror = (error) => reject(error);
//     reader.readAsDataURL(file);
//   });
// };

// // Async thunk for posting client incident data
// export const submitClientIncident = createAsyncThunk<
//   { message: string },
//   ClientIncidentFormData,
//   { rejectValue: string }
// >('clientIncident/submitClientIncident', async (formData, { rejectWithValue, dispatch }) => {
//   try {
//     // Retrieve data from localStorage
//     const project = JSON.parse(localStorage.getItem('selectedProject') || '{}') as {
//       projectId?: string;
//     };
//     const service = JSON.parse(localStorage.getItem('servicesState') || '{}') as {
//       selectedServiceTitle?: string;
//     };
//     const selectedClient = JSON.parse(localStorage.getItem('selectedClient') || '{}') as {
//       email?: string;
//     };
//     const client_email = selectedClient.email || '';

//     if (!project.projectId || !service.selectedServiceTitle || !client_email) {
//       return rejectWithValue('Missing project, service, or client information in localStorage');
//     }

//     // Handle photo: convert File to base64, keep string as is, or use empty string
//     let photoField: string = '';
//     if (formData.photo instanceof File) {
//       photoField = await convertFileToBase64(formData.photo);
//     } else if (typeof formData.photo === 'string') {
//       photoField = formData.photo;
//     }

//     const payload = {
//       id: formData.id,
//       group_id: project.projectId,
//       service_name_id: service.selectedServiceTitle,
//       client_email,
//       date: formData.date_of_incident,
//       time: formData.time_of_incident,
//       location: formData.location_of_incident,
//       description: formData.description,
//       individuals_involved: formData.individuals_involved,
//       witnesses: formData.witnesses || '',
//       actions_during: formData.actions_taken_during,
//       client_name: formData.client_name,
//       ndis_number: formData.ndis_number,
//       client_condition: formData.client_condition,
//       was_injured: formData.was_injured,
//       injury_description: formData.injury_description || '',
//       first_aid_provided: formData.first_aid_provided || '',
//       property_damage: formData.property_damage,
//       damage_description: formData.damage_description || '',
//       immediate_actions: formData.immediate_actions,
//       escalated_to_management: formData.escalated_to_management,
//       manager_name: formData.manager_name || '',
//       reported_externally: formData.reported_externally,
//       resolved: formData.resolved,
//       external_party: formData.external_party || '',
//       follow_up: formData.follow_up,
//       recommendations: formData.recommendations,
//       support_worker_name: formData.support_worker_name,
//       support_worker_signature: formData.support_worker_signature,
//       date_completed: formData.date_completed,
//       photo: photoField
//     };

//     const response = await axiosInstance.post('/ndis/form/client-incident', payload);
//     await dispatch(fetchIncidents({ client_email })).unwrap();
//     return response.data;
//   } catch (error: any) {
//     return rejectWithValue(error.response?.data?.message || 'Failed to submit client incident');
//   }
// });

// const clientIncidentSlice = createSlice({
//   name: 'clientIncident',
//   initialState,
//   reducers: {
//     clearClientIncidentState: (state) => {
//       state.loading = false;
//       state.message = null;
//       state.error = null;
//     }
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(submitClientIncident.pending, (state) => {
//         state.loading = true;
//         state.message = null;
//         state.error = null;
//       })
//       .addCase(submitClientIncident.fulfilled, (state, action) => {
//         state.loading = false;
//         state.message = action.payload.message || 'Client incident submitted successfully';
//         state.error = null;
//       })
//       .addCase(submitClientIncident.rejected, (state, action) => {
//         state.loading = false;
//         state.message = null;
//         state.error = action.payload as string;
//       });
//   }
// });

// export const { clearClientIncidentState } = clientIncidentSlice.actions;
// export default clientIncidentSlice.reducer;


import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from 'Services/APIService';
import { fetchIncidents } from '../carporateServices/IncidentsListSlice';

// Define the form data type
export interface ClientIncidentFormData {
  id?: string;
  date_of_incident: string;
  time_of_incident: string;
  location_of_incident: string;
  description: string;
  individuals_involved: string;
  witnesses?: string;
  actions_taken_during: string;
  client_name: string;
  ndis_number: string;
  client_condition: string;
  was_injured: string;
  injury_description?: string;
  first_aid_provided?: string;
  property_damage: string;
  damage_description?: string;
  immediate_actions: string;
  escalated_to_management: string;
  manager_name?: string;
  reported_externally: string;
  external_party?: string;
  follow_up: string;
  recommendations: string;
  support_worker_name: string;
  support_worker_signature: string;
  date_completed: string;
  photo?: File | string;
  client_email?: string;
  resolved?: string; // Changed to string
}

// Define the state type
export interface ClientIncidentState {
  loading: boolean;
  message: string | null;
  error: string | null;
}

// Define the initial state
const initialState: ClientIncidentState = {
  loading: false,
  message: null,
  error: null
};

// Helper function to convert file to base64
const convertFileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
    reader.readAsDataURL(file);
  });
};

// Async thunk for posting client incident data
export const submitClientIncident = createAsyncThunk<
  { message: string },
  ClientIncidentFormData,
  { rejectValue: string }
>('clientIncident/submitClientIncident', async (formData, { rejectWithValue, dispatch }) => {
  try {
    // Retrieve data from localStorage
    const project = JSON.parse(localStorage.getItem('selectedProject') || '{}') as {
      projectId?: string;
    };
    const service = JSON.parse(localStorage.getItem('servicesState') || '{}') as {
      selectedServiceTitle?: string;
    };
    const selectedClient = JSON.parse(localStorage.getItem('selectedClient') || '{}') as {
      email?: string;
    };
    const client_email = selectedClient.email || '';

    if (!project.projectId || !service.selectedServiceTitle || !client_email) {
      return rejectWithValue('Missing project, service, or client information in localStorage');
    }

    // Handle photo: convert File to base64, keep string as is, or use empty string
    let photoField: string = '';
    if (formData.photo instanceof File) {
      photoField = await convertFileToBase64(formData.photo);
    } else if (typeof formData.photo === 'string') {
      photoField = formData.photo;
    }

    const payload = {
      id: formData.id,
      group_id: project.projectId,
      service_name_id: service.selectedServiceTitle,
      client_email,
      date: formData.date_of_incident,
      time: formData.time_of_incident,
      location: formData.location_of_incident,
      description: formData.description,
      individuals_involved: formData.individuals_involved,
      witnesses: formData.witnesses || '',
      actions_during: formData.actions_taken_during,
      client_name: formData.client_name,
      ndis_number: formData.ndis_number,
      client_condition: formData.client_condition,
      was_injured: formData.was_injured,
      injury_description: formData.injury_description || '',
      first_aid_provided: formData.first_aid_provided || '',
      property_damage: formData.property_damage,
      damage_description: formData.damage_description || '',
      immediate_actions: formData.immediate_actions,
      escalated_to_management: formData.escalated_to_management,
      manager_name: formData.manager_name || '',
      reported_externally: formData.reported_externally,
      resolved: formData.resolved || '', // Send as string
      external_party: formData.external_party || '',
      follow_up: formData.follow_up,
      recommendations: formData.recommendations,
      support_worker_name: formData.support_worker_name,
      support_worker_signature: formData.support_worker_signature,
      date_completed: formData.date_completed,
      photo: photoField
    };

    const response = await axiosInstance.post('/ndis/form/client-incident', payload);
    await dispatch(fetchIncidents({ client_email })).unwrap();
    return response.data;
  } catch (error: any) {
    return rejectWithValue(error.response?.data?.message || 'Failed to submit client incident');
  }
});

const clientIncidentSlice = createSlice({
  name: 'clientIncident',
  initialState,
  reducers: {
    clearClientIncidentState: (state) => {
      state.loading = false;
      state.message = null;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(submitClientIncident.pending, (state) => {
        state.loading = true;
        state.message = null;
        state.error = null;
      })
      .addCase(submitClientIncident.fulfilled, (state, action) => {
        state.loading = false;
        state.message = action.payload.message || 'Client incident submitted successfully';
        state.error = null;
      })
      .addCase(submitClientIncident.rejected, (state, action) => {
        state.loading = false;
        state.message = null;
        state.error = action.payload as string;
      });
  }
});

export const { clearClientIncidentState } = clientIncidentSlice.actions;
export default clientIncidentSlice.reducer;